import React, {
  useEffect,
  useMemo,
  useContext,
  ReactNode,
} from 'react';

import api from 'api';
import useRequest from 'hooks/useRequest';

interface AppContextType {
  tinyMCE?: string;
}

interface TinyMCEData {
  tinyMCE: string;
}

interface AppContextProviderProps {
  children: ReactNode;
}

const AppContext = React.createContext<AppContextType>({});

export const AppContextProvider: React.FC<AppContextProviderProps> = ({ children }) => {
  const { doRequest: getToken, data } = useRequest(api.getTinyMCEToken);

  const tinyData = (data && typeof data === 'object') ? (data as TinyMCEData) : undefined;

  useEffect(() => {
    getToken(undefined);
  }, [getToken]);

  const value = useMemo<AppContextType>(
    () => ({
      tinyMCE: tinyData?.tinyMCE,
    }),
    [tinyData],
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppContext = (): AppContextType => useContext(AppContext);
